import { claimStatusValues } from '@/common/constants'

export const claimStatusOptions = [
  { value: claimStatusValues.announce, label: 'Recibido' },
  { value: claimStatusValues.opened, label: 'Abierto' },
  { value: claimStatusValues.inReview, label: 'En revisión' },
  { value: claimStatusValues.approved, label: 'Aprobado' },
  { value: claimStatusValues.denied, label: 'Denegado' },
  { value: claimStatusValues.closed, label: 'Cerrado' },
]
